// extracted by mini-css-extract-plugin
export default {"baseSelect":"styles_baseSelect__SroQQ","rootBaseSelect":"styles_rootBaseSelect__txU2j"};